import { type CSSProperties, type ReactNode } from 'react';
import classNames from 'classnames';

type SubtleBadgeProps = {
  bg?: string;
  pill?: boolean;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

const SubtleBadge = ({
  bg = 'primary',
  pill,
  children,
  className,
  style
}: SubtleBadgeProps) => {
  return (
    <div
      style={{ lineHeight: 0.75, ...style }}
      className={classNames(className, `badge badge-subtle-${bg}`, {
        'rounded-pill': pill
      })}
    >
      {children}
    </div>
  );
};

export default SubtleBadge;
